ApplicationSerializer = require './application'


App.ClientSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    phones:
      deserialize: 'records'
    client_tags:
      serialize: 'ids'
    addresses:
      deserialize: 'records'
      serialize:   false